<template>
  <div class="pt-4">
    <!-- Name, month, year GB child START -->
    <div class="pt-2">
      <input
        class="w-full bg-white h-14 px-5 rounded focus:outline-none"
        type="text"
        name="gb_child_name"
        placeholder="Vorname Kind"
        @input="$emit('input', $event.target.value)"
        v-model="child.name"
      />
      <div class="grid grid-cols-1 pt-3 md:grid-cols-2 gap-y-1 gap-x-4">
        <!--  Dropdown month START -->
        <div class="relative inline-block text-left">
          <div>
            <div
              @click="child.month.isVisible = !child.month.isVisible"
              class="flex items-center cursor-pointer"
            >
              <input
                type="text"
                placeholder="Geburtsmonat*"
                v-model.trim="$v.child.month.value.$model"
                @input="$emit('input', $event.target.value)"
                class="inline-flex w-full h-14 rounded px-4 py-4 bg-white focus:outline-none dropdown"
                :class="[
                  submitStatus == 'ERROR' && !$v.child.month.value.required
                    ? 'error'
                    : '',
                ]"
                aria-haspopup="true"
                aria-expanded="true"
                readonly
              />
              <!-- icon dropdown -->
              <svg
                class="absolute fill-current text-mcdonalds-yellow right-0 mr-3 h-8 w-8"
                :class="[child.month.isVisible ? 'transform rotate-180' : '']"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <div class="text-red-600 text-sm pt-2">
              <p
                v-if="submitStatus == 'ERROR' && !$v.child.month.value.required"
              >
                Erforderlich
              </p>
            </div>
          </div>
          <!-- Dropdown values START -->
          <div
            v-if="child.month.isVisible"
            class="origin-top-right absolute right-0 w-full rounded-b-2xl bg-white shadow-lg dropdownValues"
            :class="[submitStatus == 'ERROR' ? '' : '-mt-5']"
          >
            <div
              class="py-1"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              <div
                class="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                role="menuitem"
                v-for="(monthName, index) in germanMonths"
                :key="index"
                @click="
                  (child.month.value = monthName),
                    (child.month.isVisible = !child.month.isVisible)
                "
              >
                {{ monthName }}
              </div>
            </div>
          </div>
          <!-- Dropdown values END -->
        </div>
        <!--  Dropdown month END -->
        <!--  Dropdown year START -->
        <div class="relative inline-block text-left">
          <div
            @click="child.year.isVisible = !child.year.isVisible"
            class="flex items-center cursor-pointer"
          >
            <input
              type="text"
              placeholder="Geburtsjahr"
              v-model="child.year.value"
              @input="$emit('input', $event.target.value)"
              class="inline-flex w-full h-14 rounded px-4 py-4 bg-white focus:outline-none dropdown"
              aria-haspopup="true"
              aria-expanded="true"
              readonly
            />
            <!-- icon dropdown -->
            <svg
              class="absolute fill-current text-mcdonalds-yellow right-0 mr-3 h-8 w-8"
              :class="[child.year.isVisible ? 'transform rotate-180' : '']"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </div>

          <!-- Dropdown values START -->
          <div
            v-if="child.year.isVisible"
            class="origin-top-right absolute right-0 -mt-3 w-full rounded-b-2xl bg-white shadow-lg dropdownValues"
          >
            <div
              class="py-1"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              <div
                v-for="yearNumber in 10"
                :key="yearNumber"
                class="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                role="menuitem"
                @click="
                  (child.year.value =
                    new Date().getFullYear() + 1 - 3 - yearNumber),
                    (child.year.isVisible = !child.year.isVisible)
                "
              >
                {{ new Date().getFullYear() + 1 - 3 - yearNumber }}
              </div>
            </div>
          </div>
        </div>
        <!--  Dropdown year END -->
      </div>
    </div>
    <!-- Name, month, year GB child END -->
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    child: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      submitStatus: null,
      germanMonths: [
        "Jänner",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
      ],
    };
  },
  validations: {
    child: {
      month: {
        value: {
          required,
        },
      },
    },
  },
  methods: {
    submit() {
      // run vuelidate and check if there some errors
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        this.child.validationSuccess = false;
      } else {
        // change submit status
        this.child.validationSuccess = true;
        this.submitStatus = "OK";
      }
    },
  },
};
</script>
